(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["alice-product-panels"] && !Shopify.designMode) return;
  try {
    (() => {
    function initialise(scope) {
      scope.querySelectorAll('.alice-product-panels:not([data-alice-ready])').forEach(root => {
        root.dataset.aliceReady = 'true';
        const source = root.querySelector('[data-alice-description]');
        const labels = root.querySelector('[data-alice-panel-labels]').dataset;
        const groups = { description: document.createDocumentFragment(), composition: document.createDocumentFragment(), sizing: document.createDocumentFragment(), advice: document.createDocumentFragment() };
        let current = 'description';
        const normalise = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[’‘]/g, "'").trim().toLowerCase();
        Array.from(source.childNodes).forEach(node => {
          const text = normalise(node.textContent || '');
          if (node.nodeType === 1) {
            if (/^(composition|matiere|matieres|entretien)\s*[:：]/.test(text)) current = 'composition';
            else if (/^(taille(?:s)?|taille et coupe|taille & coupe|conseil(?:s)? de taille|coupe et taille)\s*[:：]/.test(text)) current = 'sizing';
            else if (/^(le conseil d'alice|conseil d'alice|conseils? look|idee look)\s*[:：]/.test(text)) current = 'advice';
            else if (/^(description|les details|les details qu'on aime|details)\s*[:：]/.test(text)) current = 'description';
          }
          groups[current].append(node);
        });
        source.append(groups.description);
        ['composition', 'sizing'].forEach(key => {
          if (!groups[key].textContent.trim()) return;
          const details = document.createElement('details');
          details.className = 'alice-product-panel';
          const summary = document.createElement('summary');
          summary.textContent = labels[key];
          const content = document.createElement('div');
          content.className = 'alice-product-copy rte';
          content.append(groups[key]);
          details.append(summary, content);
          root.append(details);
        });
        if (groups.advice.textContent.trim()) {
          const aside = document.createElement('aside');
          aside.className = 'alice-product-advice';
          const heading = document.createElement('h2');
          heading.textContent = labels.advice;
          const content = document.createElement('div');
          content.className = 'alice-product-copy rte';
          content.append(groups.advice);
          aside.append(heading, content);
          root.append(aside);
        }
        if (!source.textContent.trim()) root.querySelector('.alice-product-panel').hidden = true;
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document));
    else initialise(document);
    document.addEventListener('shopify:section:load', event => initialise(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
